<template>
  <v-dialog v-model="show" max-width="700px" persistent>
    <v-card class="pa-3">
      <v-card-title class="primary elevation-4">
        <span class="headline white--text">
          {{
            userPermission.id === 0
              ? 'New User Permission'
              : 'Update User Permission'
          }}
        </span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 sm6 md6>
              <ValidationProvider
                name="user"
                rules="required"
                v-slot="{ errors }"
              >
                <v-select
                  dense
                  label="Application"
                  name="application"
                  :error-messages="errors"
                  :value="userPermission.application"
                  v-model="userPermission.application"
                  :items="applicationOptions"
                ></v-select>
              </ValidationProvider>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <ValidationProvider
                name="email"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  label="Email"
                  name="email"
                  type="email"
                  :error-messages="errors"
                  v-model="userPermission.email"
                ></v-text-field>
              </ValidationProvider>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <ValidationProvider
                name="company"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  name="company"
                  label="company"
                  v-model="userPermission.company"
                  :error-messages="errors"
                ></v-text-field>
              </ValidationProvider>
            </v-flex>
            <v-flex xs12 sm6 md6>
              <ValidationProvider
                name="Option"
                rules="required"
                v-slot="{ errors }"
              >
                <v-select
                  dense
                  label="Permission Group"
                  name="permissionGroup"
                  :error-messages="errors"
                  v-model="userPermission.permissionGroup"
                  :items="permissionLevelOptions"
                ></v-select>
              </ValidationProvider>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="save">Save</v-btn>
        <v-btn color="light-grey" @click="hide">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { UserPermission } from '../../../models/UserPermission';
import SelectPermission from './permissions-select.vue';
export default {
  name: 'UserPermissionDialog',
  components: {
    SelectPermission,
  },
  data() {
    return {
      applicationOptions: [
        { id: 0, value: 'sog', text: 'Sog' },
        { id: 1, value: 'vonexAdmin', text: 'VonexAdmin' },
        { id: 3, value: 'commission', text: 'Commission' },
        { id: 4, value: 'partnerAdmin', text: 'PartnerAdmin' },
      ],
      permissionLevelOptions: [
        {
          text: 'Administrators',
          value: 1,
        },
        {
          text: 'Dealer',
          value: 2,
        },
        {
          text: 'DealerManagers',
          value: 3,
        },
        {
          text: 'Helpdesk',
          value: 4,
        },
      ],
      userPermission: new UserPermission(),
    };
  },
  props: {
    show: { type: Boolean, required: true },
  },
  methods: {
    hide() {
      this.$emit('hide');
    },
    save() {
      this.$emit('save', this.userPermission);
    },
    handleChange(val) {},
    remove() {
      if (confirm('Do you want to remove this item?')) {
        this.$emit('remove', this.userPermission.id);
      }
    },
  },
};
</script>
